import Text from "@/components/Text";
import Spacer from "@/components/Spacer";
import { DialogProps } from "./props.type";
import { DialogContent, DialogTextWrapper } from "./styles";
import { Box, Dialog as MUIDialog, IconButton } from "@mui/material";
import Theme, { dialogBackdropSx } from "@/utils/theme";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@/components/Button";
import InfoIcon from "@/ui/icons/InfoIcon";
import reactStringReplace from "react-string-replace";
import CloseIcon from "@mui/icons-material/Close";

const Dialog = ({
  isOpen,
  icon,
  text,
  confirmButtonText = "Entendi",
  confirmButtonDisabled = false,
  onConfirm,
  closeButtonText = "Cancelar",
  onClose,
  onDismiss,
  isLoading,
  content,
  footer,
  iconSize,
  variantButtonConfirm = "contained",
  maxWidth = "20rem",
  preventBackdropClose = false,
}: DialogProps) => {
  const blockInteraction = isLoading || preventBackdropClose;

  return (
    <MUIDialog
      open={isOpen}
      BackdropProps={{ sx: dialogBackdropSx }}
      onClose={
        blockInteraction
          ? () => {}
          : onDismiss
            ? (_event, reason) => {
                if (reason === "backdropClick" || reason === "escapeKeyDown") {
                  onDismiss();
                }
              }
            : undefined
      }
    >
      <Box sx={{ position: "relative", width: "100%" }}>
        {onDismiss && (
          <IconButton
            type="button"
            aria-label="Fechar"
            onClick={isLoading ? () => {} : onDismiss}
            disabled={isLoading}
            size="small"
            sx={{
              position: "absolute",
              top: 4,
              right: 4,
              zIndex: 1,
              color: Theme.colors.text.primary,
            }}
          >
            <CloseIcon sx={{ fontSize: "1.35rem" }} />
          </IconButton>
        )}
        <DialogContent $maxWidth={maxWidth} $hasDismiss={!!onDismiss}>
        {icon}
        {!icon && <InfoIcon size={iconSize} />}

        {text ? (
          <DialogTextWrapper>
            <Text
              component="span"
              display="inline-block"
              fontSize="1rem"
              align="center"
              lineHeight="1.2rem"
            >
              {reactStringReplace(text, /\[b\]([\s\S]+?)\[\/b\]/g, (match, index) => {
                return (
                  <Text
                    key={index}
                    component="span"
                    fontSize="1rem"
                    fontWeight={"700"}
                  >
                    {match}
                  </Text>
                );
              })}
            </Text>
          </DialogTextWrapper>
        ) : null}

        {content}

        <Button
          onClick={isLoading ? () => {} : onConfirm}
          disableRipple={isLoading}
          disabled={isLoading || confirmButtonDisabled}
          variant={variantButtonConfirm}
        >
          {isLoading ? (
            <CircularProgress style={{ color: "white" }} size="1rem" />
          ) : (
            <Text
              color={
                variantButtonConfirm === "outlined"
                  ? Theme.colors.button.text
                  : Theme.colors.button.contained.primary.text
              }
              fontSize="1rem"
            >
              {confirmButtonText}
            </Text>
          )}
        </Button>

        {onClose && (
          <>
            <Spacer height="1.5rem" />
            <Button
              onClick={isLoading ? () => {} : onClose}
              variant="outlined"
              disabled={isLoading}
              disableRipple={isLoading}
            >
              <Text
                fontSize="1rem"
                color={isLoading ? Theme.colors.text.secondary : Theme.colors.button.text}
              >
                {closeButtonText}
              </Text>
            </Button>
          </>
        )}

        <Spacer height="1.5rem" />
      </DialogContent>
      </Box>

      {footer}
    </MUIDialog>
  );
};

export default Dialog;
